import { find, isArray, toInteger } from 'lodash'
import { mapGetters, mapState } from 'vuex'

export default
{
	props:
	{
		zoneRecordId:
		{
			type:    [ Number, String ],
			default: null,
		},

		zoneMasterId:
		{
			type:    [ Number, String ],
			default: null,
		},
	},

	computed:
	{
		...mapState
		({
			zone:           state => state.zones.zone,
			zoneFile:       state => state.zones.file,
			ipAddressWhois: state => state.zones.whois,
			ipAddressDig:   state => state.zones.dig,
		}),

		...mapGetters
		([
			'hasZone',
			'whoisError',
			'digError',
		]),

		isZonePrimary()
		{
			const { hasZone, zone } = this

			return hasZone && zone?.is_primary
		},

		isZoneSecondary()
		{
			const { hasZone, isZonePrimary } = this

			return hasZone && !isZonePrimary
		},

		zoneName()
		{
			const { zone } = this

			return zone?.name
		},

		zoneMaster()
		{
			const { zone, zoneMasterId } = this

			return zoneMasterId && find(zone?.ip_addresses, [ 'id', toInteger(zoneMasterId) ])
		},

		zoneRecord()
		{
			const { zone, zoneRecordId } = this

			return zoneRecordId && find(zone?.records, [ 'id', toInteger(zoneRecordId) ])
		},

		hasMultipleZoneRecords()
		{
			const { records } = this.zone ?? {}

			return isArray(records) && records.length > 1
		},
	},
}